export { default as PlainTextViewer } from './plain-text-viewer.component';
